module.exports = __webpack_public_path__ + "media/images/empty_heart-18740d3b.svg";